import BaseResource from './index'
import { randomStringGenerate } from '../util'
import { emailIsValid } from './helpers/validation'
import ReservationResource from './reservation'

export default class UserResource extends BaseResource {
    static endpoint = '/users'

    static fields = ['id', 'password', 'username', 'email', 'first_name', 'last_name', 'location', 'phone', 'zip_code', 'racer_name', 'flag_code', 'social_instagram', 'opt_in_account_updates', 'opt_in_marketing_updates']

    static defaults = {
        password: () => {
            return randomStringGenerate()
        }
    }

    static related() {
        return {
            location: require('./location').default
        }
    }

    static validation = {
        email: emailIsValid
    }

    static login(username, password) {
        return UserResource.client
            .post(`/auth/token`, { username, password })
            .then((res) => {
                return res.data.access
            })
            .then((token) => {
                BaseResource.client.token = token
                let payload = BaseResource.client.getTokenPayload()
                if (payload['user_id']) {
                    return UserResource.detail(payload['user_id'])
                } else {
                    return new UserResource()
                }
            }).then(userResource => {
                return {
                    userResource,
                    token: BaseResource.client.token
                }
            })
    }

    async setPassword(newPassword) {
        // @todo fix weird network bug
        // return await UserResource.client.post(`${UserResource.endpoint}/${this.id}/update_password`, { new_password: newPassword })
        try {
            await UserResource.client.post(`${UserResource.endpoint}/${this.id}/update_password`, { new_password: newPassword })
        } catch(e) {
            // Do nothing for now
        }
    }

    static async forgotPassword(email) {
        return await UserResource.client.post(`${UserResource.endpoint}/forgot_password`, { email }, { headers: {} })
    }

    static async getReservationsFuture() {
        let wrapped = this.wrap('/me/reservations/future')
        let page = await wrapped.get({ params: { group_base: true, future: true } })
        let contentNegotiator = this.client.negotiateContent(ReservationResource)
        return contentNegotiator(page)
    }

    async getPermissions() {
        let result = await UserResource.client.get(`/auth/permissions`)
        return result.data
    }

    displayName() {
        return this.attributes.display_name || this.racerName() || this.fullName()
    }

    racerName() {
        return this.attributes.racer_name
    }

    fullName() {
        let hiString = [this.get('first_name'), this.get('last_name')].filter((v) => !!v).join(' ')
        if (!hiString.length) {
            hiString = this.get('email')
        }
        
        return hiString
    }

    isOnboarded() {
        return this.get('is_onboarded')
    }

    toString() {
        return this.displayName()
    }

    async addCard(token) {
        let endpoint = UserResource.getDetailRoutePath(this.id)
        let result = await UserResource.client.post(`${endpoint}/card`, { token })
        this._card = result.data
        return this._card
    }

    async deleteCard() {
        let endpoint = UserResource.getDetailRoutePath(this.id)
        let result = await UserResource.client.delete(`${endpoint}/card`)
        return result.data
    }

    async getCard(force) {
        if(this._card && !force) {
            return this._card
        }

        let endpoint = UserResource.getDetailRoutePath(this.id)
        let result = await UserResource.client.get(`${endpoint}/card`)
        this._card = result.data
        return this._card
    }

    async getHistory(options = { pageSize: 50 }) {
        // Circular dependency, so lazy load this resource
        const ReservationResource = require('./reservation').default
        let page = await ReservationResource.list({ resolveRelated: true, query: { user: this.id, group_base: true, ordering: 'slot', page_size: options.pageSize } })
        return page.resources
    }

    async getBalanceDetails() {
        let wrapped = this.wrap('/balance')
        let result = await wrapped.get()
        return result.data
    }

    async markAsPaid() {
        let wrapped = this.wrap('/clear_outstanding')
        let result = await wrapped.post()
        return result.data
    }
}
